import { FC, useState } from "react";
import Passengers from "../../shared/svgs/Passengers";
import PassengerNamesModal from "./PassengerNamesModal";

interface IPassengersBadgeProps {
  count: number;
  uniqueJourneyId?: string;
  onSuccess?: () => void;
}

const content = (count: number) => (
  <>
    <p className="mr-1 text-sm">{count}</p>
    <span className="w-4 h-4">
      <Passengers />
    </span>
  </>
);

const PassengersBadge: FC<IPassengersBadgeProps> = ({
  count,
  uniqueJourneyId,
  onSuccess
}) => {
  const [show, setShow] = useState(false);

  // No role check here on purpose. The passenger endpoints are gated server-side by
  // [SuperAdminRoleFilter], which admits SuperAdmin *and* CustomerSupport — a client-side
  // SuperAdmin hook would wrongly lock CustomerSupport out, and duplicating the backend's
  // role logic in the UI would be a second source of truth to keep in sync. Anyone without
  // access gets a clear message from the modal instead.
  if (!uniqueJourneyId) {
    return <div className="flex">{content(count)}</div>;
  }

  // stopPropagation so a click on a reservation card (list view) does not also trigger the
  // card's navigate-to-edit.
  return (
    <span onClick={(e) => e.stopPropagation()}>
      <button
        type="button"
        onClick={() => setShow(true)}
        title="Shiko dhe modifiko pasagjerët"
        className="flex items-center rounded px-1 -mx-1 cursor-pointer
        hover:bg-primary/10 focus:outline-none"
      >
        {content(count)}
      </button>
      {show && (
        <PassengerNamesModal
          show={show}
          onClose={() => setShow(false)}
          uniqueJourneyId={uniqueJourneyId}
          onSuccess={onSuccess}
        />
      )}
    </span>
  );
};

export default PassengersBadge;
